// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607010751/js/" + chunkId + "." + {"44":"d76913b2","225":"32668d85","481":"6d6571e8","486":"024a887d","770":"173a6dae"}[chunkId] + ".0.760555972922194.chunk.js";
};